import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styles: [
  ]
})
export class BadgeComponent implements OnInit {
  @Input() label: string;
  @Input() color = 'primary';
  constructor() { }

  ngOnInit(): void {
  }

}
